import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */
export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingRow',
                },
                null,
              ],
            },
            'Edit Personnel Row',
          ],
          'Add Personnel Row',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'personnelId',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_personnel#!entry:!personnel',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'personnelId',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_personnel#!entry:!type',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'type',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'code',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_personnel#!entry:!code',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'code',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_personnel#!entry:!name',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'name',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'id',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!proposal_personnel#!entry:!id',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingRow',
                      },
                      'id',
                    ],
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'save.proposal.personnel.row',
                },
              },
              variables: {
                '{}': {
                  code: '${field:code}',
                  name: '${field:name}',
                  type: '${field:type}',
                  proposalId: {
                    '@$': 'proposalId',
                  },
                  personnelId: '${field:personnelId}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingRow: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'proposalPersonnelId',
          },
        ],
      },
      target: 'ent:!proposal_personnel:!entry',
      quantity: 1,
      selection: {
        '{}': {
          id: {
            '@.': '!id',
          },
          type: {
            '@.': '!type',
          },
          personnelId: {
            '@': 'personnelRecordId',
          },
        },
      },
      subqueries: {
        personnelRecordId: {
          ref: {
            attr: 'attr:ent#!proposal_personnel#!entry:!personnel',
          },
          target: 'ent:!personnel:!employee',
          selection: {
            '@.': '!id',
          },
        },
      },
    },
  },
}
